import { render, staticRenderFns } from "./tagGroup.vue?vue&type=template&id=0dfb85f4&"
import script from "./tagGroup.vue?vue&type=script&lang=js&"
export * from "./tagGroup.vue?vue&type=script&lang=js&"
import style0 from "./tagGroup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports